<div class="scorecard-item" [class.has-data]="!!data" [class.is-loading]="isLoading">
    <!-- Filter selector header -->
    <div class="scorecard-header" *ngIf="externalLabel !== null || !hideFilterSelect">
        <ng-container *ngIf="externalLabel !== null">
            <div class="external-label-header">
                <span *ngIf="accentColor" class="accent-dot" [style.background-color]="accentColor"></span>
                <span class="external-label-text">{{ externalLabel }}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="externalLabel === null">
            <select class="filter-select" [ngModel]="filterId ?? ''" (change)="onFilterChange($event)">
                <option value="">{{ 'FEATURES.SCORECARD.SELECT_PLACEHOLDER' | translate }}</option>
                <option *ngFor="let f of availableFilters; trackBy: trackById" [value]="f.id">{{ f.name }}</option>
            </select>
            <button
                *ngIf="filterId"
                class="clear-btn text"
                type="button"
                (click)="filterSelected.emit(null)"
                [title]="'BUTTONS.CLEAR' | translate"
            >
                <span class="material-symbols-rounded" aria-hidden="true">close</span>
            </button>
        </ng-container>
    </div>

    <!-- Loading state -->
    <div *ngIf="isLoading" class="scorecard-loading">
        <span class="material-symbols-rounded spinner" aria-hidden="true">progress_activity</span>
    </div>

    <!-- Empty/placeholder state -->
    <div *ngIf="!isLoading && !data && !filterId" class="scorecard-empty">
        <span class="material-symbols-rounded" aria-hidden="true">query_stats</span>
        <p>{{ 'FEATURES.SCORECARD.SELECT_PLACEHOLDER' | translate }}</p>
    </div>

    <!-- No data after filter selected -->
    <div *ngIf="!isLoading && !data && filterId" class="scorecard-empty">
        <span class="material-symbols-rounded" aria-hidden="true">query_stats</span>
        <p>{{ 'FEATURES.SCORECARD.NO_DATA' | translate }}</p>
    </div>

    <!-- Scorecard body -->
    <div *ngIf="!isLoading && data" class="scorecard-body">
        <!-- TQi gauge section -->
        <div class="tqi-section">
            <svg class="tqi-gauge" viewBox="0 0 100 58" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <!-- Background arc -->
                <path
                    class="gauge-bg"
                    d="M 8 52 A 42 42 0 0 1 92 52"
                    fill="none"
                    stroke-width="8"
                    stroke-linecap="round"
                />
                <!-- Value arc -->
                <path
                    [class]="'gauge-fill ' + gaugeColorClass"
                    d="M 8 52 A 42 42 0 0 1 92 52"
                    fill="none"
                    stroke-width="8"
                    stroke-linecap="round"
                    [style.stroke-dasharray]="gaugeArcLength"
                    [style.stroke-dashoffset]="gaugeDashOffset"
                />
            </svg>
            <div class="tqi-values">
                <span [appTooltip]="'FEATURES.SCORECARD.METRICS.TQI_TOOLTIP' | translate" class="tqi-label">{{
                    'FEATURES.SCORECARD.METRICS.TQI' | translate
                }}</span>
                <span class="tqi-score">{{ data.tQi | number: '1.0-1' }}</span>
                <span
                    *ngIf="baseData"
                    class="tqi-delta"
                    [class.delta-positive]="tqiDelta > 0"
                    [class.delta-negative]="tqiDelta < 0"
                    [class.delta-neutral]="tqiDelta === 0"
                >
                    {{ formatDelta(tqiDelta) }}
                </span>
            </div>
        </div>

        <!-- Metric bars -->
        <div class="metrics-section">
            <div *ngFor="let metric of metrics" class="metric-row">
                <span [appTooltip]="metric.labelKey + '_TOOLTIP' | translate" class="metric-label">{{
                    metric.labelKey | translate
                }}</span>
                <div class="metric-bar-track">
                    <div class="metric-bar-fill" [style.width.%]="getMetricValue(metric)"></div>
                </div>
                <div class="metric-value-group">
                    <span class="metric-value">{{ getMetricValue(metric) | number: '1.0-1' }}%</span>
                    <span
                        *ngIf="baseData"
                        class="metric-delta"
                        [class.delta-positive]="getDelta(metric) > 0"
                        [class.delta-negative]="getDelta(metric) < 0"
                        [class.delta-neutral]="getDelta(metric) === 0"
                    >
                        {{ formatDelta(getDelta(metric)) }}%
                    </span>
                </div>
            </div>
        </div>
        <span [appTooltip]="'FEATURES.SCORECARD.MEASUREMENTS_TOOLTIP' | translate" class="cases-label"
            >{{ 'FEATURES.SCORECARD.MEASUREMENTS' | translate }}: {{ data?.measurements }}</span
        >
    </div>
</div>
